/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface ShowModel
 */
export interface ShowModel {
    /**
     *
     * @type {string}
     * @memberof ShowModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ShowModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ShowModel
     */
    type: string;
    /**
     *
     * @type {FileUrl}
     * @memberof ShowModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ShowModel interface.
 */
export function instanceOfShowModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function ShowModelFromJSON(json: any): ShowModel {
    return ShowModelFromJSONTyped(json, false);
}

export function ShowModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        type: json['type'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ShowModelToJSON(value?: ShowModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        type: value['type'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
